export const STUDY_SPEED_SETTINGS = {
  ALL_NEW: 'ALL_NEW',
  MOSTLY_NEW: 'MOSTLY_NEW',
  DEFAULT: 'DEFAULT',
  BALANCED: 'BALANCED',
  MOSTLY_REVIEW: 'MOSTLY_REVIEW',
};
